<header #siteHeader class="site-header" *ngIf="showChrome">
  <div class="site-header__inner">
    <button type="button" class="site-header__brand" (click)="goHome()">
      <img src="assets/logo.png" [alt]="environment.appName" />
    </button>

    <nav class="site-header__nav" aria-label="التنقل الرئيسي">
      <button
        type="button"
        *ngFor="let link of navLinks; trackBy: trackNavLink"
        class="site-header__link"
        [class.is-active]="link.active"
        (click)="handleNav(link.path, $event)"
      >
        {{ link.label }}
      </button>
    </nav>

    <div class="site-header__actions">
      <button type="button" class="site-header__search" aria-label="البحث" (click)="handleNav('/search', $event)">
        <span class="theme-icon theme-icon--search" aria-hidden="true"></span>
        <span>ابحث عن منتج...</span>
      </button>

      <button type="button" class="site-header__cart" aria-label="السلة" (click)="handleNav(cartPath, $event)">
        <span class="theme-icon theme-icon--cart" aria-hidden="true"></span>
        <strong *ngIf="cartCount > 0">{{ cartCount }}</strong>
      </button>

      <div class="site-header__user" *ngIf="user?._id; else loginBtn">
        <button type="button" class="site-header__avatar" (click)="toggleMenu(); $event.stopPropagation()">
          {{ (user.name || user.phone || 'ح')[0] }}
        </button>
        <div class="site-header__menu" *ngIf="menuOpen">
          <button type="button" (click)="handleNav(ordersPath, $event)">طلباتي</button>
          <button type="button" (click)="handleNav('/tabs/tab5', $event)">حسابي</button>
          <button type="button" (click)="logout(); $event.stopPropagation()">تسجيل الخروج</button>
        </div>
      </div>

      <ng-template #loginBtn>
        <button type="button" class="site-header__login" (click)="handleNav('/login', $event)">دخول</button>
      </ng-template>
    </div>
  </div>
</header>

<div class="site-chrome__body">
  <div class="site-chrome__content">
    <ng-content></ng-content>
  </div>
  <footer class="site-footer" *ngIf="showChrome">
    <div class="site-footer__inner">
      <div class="site-footer__col site-footer__brand">
        <div class="site-footer__brand-row">
          <img class="site-footer__logo" src="assets/logo.png" [alt]="environment.appName" />
          <strong class="site-footer__app-name">{{ environment.appName }}</strong>
        </div>
        <p>تابعنا علي مواقع التواصل الاجتماعي</p>
        <div class="site-footer__social" *ngIf="socialLinks?.length">
          <a
            href="javascript:void(0)"
            *ngFor="let link of socialLinks"
            [class]="'site-footer__social-link site-footer__social-link--' + link.brand"
            [attr.aria-label]="link.label"
            (click)="openExternal(link.url, $event)"
          >
            <img [src]="link.icon" alt="" />
          </a>
        </div>
      </div>

      <div class="site-footer__col" *ngIf="footerCategories?.length">
        <h4>الفئات الأكثر شيوعاً</h4>
        <button
          type="button"
          *ngFor="let item of footerCategories; trackBy: trackFooterItem"
          [disabled]="typeof item === 'string'"
          (click)="openFooterCategory(item)"
        >
          {{ footerItemLabel(item) }}
        </button>
      </div>

      <div class="site-footer__col">
        <h4 *ngIf="footerBrands?.length">اشهر البراندات التجارية</h4>
        <button
          type="button"
          *ngFor="let item of footerBrands; trackBy: trackFooterItem"
          [disabled]="typeof item === 'string'"
          (click)="openFooterBrand(item)"
        >
          {{ footerItemLabel(item) }}
        </button>
        <button type="button" class="site-footer__explore" (click)="handleNav('/tabs/tab3', $event)">
          استكشف كل المنتجات
          <span class="theme-icon theme-icon--arrow-left theme-icon--on-dark" aria-hidden="true"></span>
        </button>
      </div>

      <div class="site-footer__col site-footer__apps" *ngIf="hasStoreLinks">
        <h4>حمل التطبيق الآن</h4>
        <a
          href="javascript:void(0)"
          class="store-btn"
          *ngIf="googlePlayUrl"
          (click)="openExternal(googlePlayUrl, $event)"
        >
          <img src="assets/icon/playstore.svg" alt="" />
          <span>
            <small>GET IT ON</small>
            Google Play
          </span>
        </a>
        <a
          href="javascript:void(0)"
          class="store-btn"
          *ngIf="appleStoreUrl"
          (click)="openExternal(appleStoreUrl, $event)"
        >
          <img src="assets/icon/apple.svg" alt="" />
          <span>
            <small>Download on the</small>
            App Store
          </span>
        </a>
      </div>
    </div>

    <div class="site-footer__copy">© 2024 جميع الحقوق محفوظة</div>
  </footer>
</div>
